import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Input, Button, Label } from 'reactstrap';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import DownloadIcon from '../../../../../../../../designUtils/ProjectDashboard/DownloadIcon.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Send from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Send.svg';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import FetchAssetsbySubmissionService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchAssetsbySubmissionService';
import AddSubmissionsChatService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddSubmissionsChatService';
import FetchSubmissionsChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService';
import ProjectDashDeliveriesImagesDetails from './ProjectDashDeliveriesImagesDetails';
import AssetsCommentsPopup from '../AssetAnnotations/AssetsCommentsPopup';
import {
  GRAPHICS_DELIVERY_FILTERS,
  DOCUMENT_DELIVERY_FILTERS,
  matchesDeliveryStatus,
  getDeliveryStatusCount,
  getDeliveryStatusDisplay,
} from './deliveriesStatusUtils';

function ProjectDashDeliveriesDetails(props) {
  const [assetList, setAssetList] = useState([]);
  const [documentSearchText, setDocumentSearchText] = useState('');
  const [imageSearchText, setImageSearchText] = useState('');
  
  // Add missing state variables for modal functionality
  const [isAttachmentOpen, setIsAttachmentOpen] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [selectedFileObject, setSelectedFileObject] = useState({});
  const [downloading, setDownloading] = useState(false);
  const [isCommentsPopUpOPen, setIsCommentsPopUpOPen] = useState(false);
  const [loadScreen, setLoadScreen] = useState(false);
  const [noteList, setNoteList] = useState([]);
  const [demoImage, setDemoImage] = useState()
  const [comment, setComment] = useState('');
  const [isImageDetails, setIsImageDetails] = useState(false);
  const [selectedImageAsset, setSelectedImageAsset] = useState(null);
  const [documentStatusFilter, setDocumentStatusFilter] = useState('All');
  const [graphicsStatusFilter, setGraphicsStatusFilter] = useState('All');
  const [loggedInUser,setLoggedInUser]= useState('');
  const [action,setAction]=useState()
  const [submissionNote, setSubmissionNote] = useState([]);
  const [documentStatusCount, setDocumentStatusCount] = useState({});
  const [documentTotal, setDocumentTotal] = useState(0);
  const [graphicsStatusCount, setGraphicsStatusCount] = useState({});
  const [graphicsTotal, setGraphicsTotal] = useState(0);
  useEffect(() => {
    const data = {
      submissionAssetId: props.submissionData.id,
    };
    setLoadScreen(true);
    FetchAssetsbySubmissionService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        setLoggedInUser(res.loggedInUser)
        setAssetList(res.assetList);
        setSubmissionNote(res.note);
        if (res.documentStatusCount) {
          setDocumentStatusCount(res.documentStatusCount);
        }
        if (res.documentTotal !== undefined) {
          setDocumentTotal(res.documentTotal);
        }
        if (res.graphicsStatusCount) {
          setGraphicsStatusCount(res.graphicsStatusCount);
        }
        if (res.graphicsTotal !== undefined) {
          setGraphicsTotal(res.graphicsTotal);
        }
      }
      setLoadScreen(false);
    });
  }, []);
  const handleImageClick = (imageAsset,flag) => {
    console.log(imageAsset)
    setSelectedImageAsset(imageAsset);
    setIsImageDetails(true);
    setAction(flag)
  };

  const submissionsChats = (asset) => {
    console.log(asset);
  
    let data = {
      assetId: asset.assetId
    }
    setSelectedFileObject(asset);
  
    setLoadScreen(true);
    FetchSubmissionsChatsService(props.token, data).then((res) => {
      console.log(res)
      setNoteList(res);
      setLoadScreen(false);
      // setComment(res)
    })
    // setAssetsName(file.actualFileName);
    setIsCommentsPopUpOPen(true);
    showNote(asset.fileName, asset.filePath)
  };

  const showNote = (path, fullPath) => {
    console.log(path);
    const ext = path.split(".")[1];
    if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx" || ext == "doc" || ext == 'xlsm') {
      setDemoImage(true)
    } else {
      setFilePath(fullPath);
      setDemoImage(false)
    }
  };

  const addSubmissionsChats = () => {
    const data = {
      notes: comment,
      assetId: selectedFileObject.assetId,
    };
  
    AddSubmissionsChatService(props.token, data).then((res) => {
      if (res) {
        setNoteList(res.noteList);
        setComment('');
        // setIsCommentsPopUpOPen(false);
      }
    });
  };
  
  // Add download functionality
  const handleDownloadImage = async (url, fileObject) => {
    try {
      setDownloading(fileObject.assetId);

      const response = await fetch(url, {
        method: 'GET',
        referrerPolicy: 'no-referrer',
        cache: 'no-store',
      });

      if (!response.ok) throw new Error(`Network response was not ok for ${fileObject.assetId}`);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = fileObject.assetName || 'downloaded_file';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(blobUrl);
      setDownloading(false);
    } catch (error) {
      console.error('Failed to download files:', error);
      setDownloading(false);
    }
  };

  // Define file extensions (matching your main component)
  const imageExtensions = ['jpg', 'jpeg', 'png'];
  const documentExtensions = ['csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm', 'pdf'];

  // Function to get file extension from filename
  const getFileExtension = (filename) => {
    if (!filename) return '';
    return filename.split('.').pop().toLowerCase();
  };

  // Filter assets into documents and images 
  const documentAssets = assetList &&assetList.filter(asset => {
    if (!asset.assetName) return false;
    const extension = getFileExtension(asset.assetName);
    return documentExtensions.includes(extension);
  });

  const imageAssets =assetList&& assetList.filter(asset => {
    if (!asset.assetName) return false;
    const extension = getFileExtension(asset.assetName);
    return imageExtensions.includes(extension);
  });

  // Apply search filters 
  const filteredDocuments = documentAssets && documentAssets.filter(asset => {
    const matchesSearch =
      (asset.assetName && asset.assetName.toLowerCase().includes(documentSearchText.toLowerCase())) ||
      String(asset.assetId || '').includes(documentSearchText);
  
    const matchesStatus = matchesDeliveryStatus(
      asset.statusText,
      documentStatusFilter,
      DOCUMENT_DELIVERY_FILTERS
    );
  
    return matchesSearch && matchesStatus;
  });

  const filteredImages = imageAssets && imageAssets.filter(asset => {
    const matchesSearch =
      (asset.assetName && asset.assetName.toLowerCase().includes(imageSearchText.toLowerCase())) ||
      String(asset.assetId || '').includes(imageSearchText);
  
    const matchesStatus = matchesDeliveryStatus(
      asset.statusText,
      graphicsStatusFilter,
      GRAPHICS_DELIVERY_FILTERS
    );
  
    return matchesSearch && matchesStatus;
  });
  
  
  const docStatusOptions = DOCUMENT_DELIVERY_FILTERS.map((item) => ({ text: item.text }));
  
  const graphicsStatusOptions = GRAPHICS_DELIVERY_FILTERS.map((item) => ({ text: item.text }));
  
  // Document table columns with working functionality
  const columns = [
    {
      Header: "Name",
      accessor: "assetName",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p  onClick={() => handleImageClick(cellInfo.original,false)} title={cellInfo.value}className="m-0 comment-paragraph cursor-pointer">{cellInfo.value}</p>
        </div>
      )
    },
    {
        Header: "Status",
        accessor: "statusText",
        Cell: (cellInfo) => (
          <div className="d-flex justify-content-center w-100">
            <p className='mb-0'>{getDeliveryStatusDisplay(cellInfo.value)}</p>
          </div>
        )
      },
    {
      Header: "Action",
      accessor: "action",
      Cell: (rowInfo) => {
        const asset = rowInfo.original;
        const fileExtension = asset.assetName ? asset.assetName.split('.').pop().toLowerCase() : '';
        const isPDF = fileExtension === 'pdf';

        return (
          <div className="d-flex justify-content-center align-items-center w-100">
            {/* <button
              onClick={() => submissionsChats(rowInfo.original)}
              className="btn"
            >
              <img
                className="comments-bg-color"
                height={20}
                width={20}
                title="Notes"
                src={CommentIcon}
              />
            </button> */}
           
            <img
              src={DownloadIcon}
              alt="Download"
              height={20}
              width={20}
              style={{ cursor: 'pointer'}}
              title="Download"
              className={
                downloading && downloading === asset.assetId
                  ? "button-img-background-download-inprogress"
                  : ""
              }
              onClick={() => {
                if (downloading !== asset.assetId) {
                  setSelectedFileObject(asset);
                  setDownloading(asset.assetId);
                  handleDownloadImage(asset.filePath || asset.url, asset);
                }
              }}
            />
          </div>
        );
      }
    }
  ];

  return (
    <>
     <Card className="card-of-problemarea p-3 mb-2 ml-3 mr-2">
     <div className="d-flex align-items-start">
          <h6 className="mr-2 mb-0"><b>Submission Note : </b></h6>
          <div>
          {
            typeof props.submissionData.note === 'string' &&
            props.submissionData.note.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim() !== '' &&
            props.submissionData.note !== '[]' ? (
              <div
                dangerouslySetInnerHTML={{ __html: props.submissionData.note }}
              />
            ) : (
              <p className="mb-0"></p>
            )
          }
          </div>
        </div>
      </Card>
      <Col md={12}>
        <Row>
          <Col md={5}>
            <Card className="card-of-problemarea p-3">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0 mr-3"><b>Documents List</b></h5>
                <Input 
                  type="text" 
                  placeholder="Search Text" 
                  className="w-50" 
                  value={documentSearchText}
                  onChange={(e) => setDocumentSearchText(e.target.value)}
                />
              </div>
              <Row>
              <Col className="d-flex flex-wrap align-items-center mt-1">
        {docStatusOptions.map((item, index) => {
          const statusCount = getDeliveryStatusCount(
            documentStatusCount,
            item.text,
            DOCUMENT_DELIVERY_FILTERS,
            documentTotal
          );
          return (
          <div key={index} className="status-radio-wrapper">
            <label
              htmlFor={`document-${item.text.replace(/\s+/g, '-')}`}
              className={`status-radio-label ${item.text.replace(/\s+/g, '-')} ${documentStatusFilter === item.text ? 'selected' : ''}`}
            >
              <input
                type="radio"
                id={`document-${item.text.replace(/\s+/g, '-')}`}
                name="documentStatusFilter"
                value={item.text}
                checked={documentStatusFilter === item.text}
                onChange={() => {
                  setDocumentStatusFilter(item.text);
                  setSelectedImageAsset(null);
                }}
              />
              <span className="mr-2"></span>
              {item.text}
              <b
            className="assetsStatusCount"
            style={{
              minWidth: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              minHeight: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              padding: `4px ${Math.max(6, (statusCount || 0).toString().length * 3)}px`
            }}
          >
            {statusCount || 0}
          </b>

            </label>
          </div>
          )
})}
      </Col>
              </Row>
              <ReactTable
                className="-fixed -highlight -striped mt-2"
                data={filteredDocuments}
                columns={columns}
                defaultPageSize={5}
                noDataText="No data found..."
                getTheadProps={() => ({
                  style: {
                    overflow: "hidden",
                    background: "#B1FA63",
                    color: "#243837",
                  }
                })}
              />
            </Card>
          </Col>
          <Col md={7} className='mt-3'>
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0 mr-3">
                  <b>Images</b>
                </h5>
                <div className="d-flex align-items-center w-75 justify-content-end mt-1">
                  <Input
                    type="text"
                    placeholder="Search"
                    className="w-50"
                    value={imageSearchText}
                    onChange={(e) => setImageSearchText(e.target.value)}
                  />
                </div>
              </div>
              <Row>
              <Col className="d-flex flex-wrap align-items-center mt-1">
        {graphicsStatusOptions.map((item, index) => {
          const statusCount = getDeliveryStatusCount(
            graphicsStatusCount,
            item.text,
            GRAPHICS_DELIVERY_FILTERS,
            graphicsTotal
          );
          return (
          <div key={index} className="status-radio-wrapper">
            <label
              htmlFor={`graphics-${item.text.replace(/\s+/g, '-')}`}
              className={`status-radio-label ${item.text.replace(/\s+/g, '-')} ${graphicsStatusFilter === item.text ? 'selected' : ''}`}
            >
              <input
                type="radio"
                id={`graphics-${item.text.replace(/\s+/g, '-')}`}
                name="graphicsStatusFilter"
                value={item.text}
                checked={graphicsStatusFilter === item.text}
                onChange={() => {
                  setGraphicsStatusFilter(item.text);
                  setSelectedImageAsset(null);
                }}
              />
              <span className="mr-2"></span>
              {item.text}
          <b
            className="assetsStatusCount"
            style={{
              minWidth: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              minHeight: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              padding: `4px ${Math.max(6, (statusCount || 0).toString().length * 3)}px`
            }}
          >
            {statusCount || 0}
          </b>


            </label>
          </div>
          )
})}
      </Col>
              </Row>
            <LoadingOverlay
                active={loadScreen}
                styles={{
                  overlay: (base) => ({
                    ...base,
                    background: '#f1f4f6',
                    opacity: 1,
                  }),
                  content: (base) => ({
                    ...base,
                    color: '#000',
                  }),
                }}
                spinner={<Loader active type="ball-pulse" />}
                text="Loading Images...">
              <Row className="mt-3">
              {filteredImages && filteredImages.length > 0 ? (
                  filteredImages.map((asset, index) => (
                    <Col md={3} key={index}>
                      <Card className="p-2 text-center submissions-image-wrapper position-relative">
                        {/* <button
                          onClick={() => submissionsChats(asset)}
                          className="btn p-0 images-note-icon"
                        >
                          <img
                            src={CommentIcon}
                            alt="Comment"
                            height={16}
                            width={16}
                            title="Notes"
                          />
                        </button> */}

                        <div
                          className={`grahics-qa-status-dot ${asset.statusText ? asset.statusText.replace(/\s+/g, '-') : ''}`}
                          style={{ backgroundColor: asset.statusColor }}
                          title={asset.statusText}
                        ></div>

                        <img
                          src={asset.filePath || asset.url}
                          alt={asset.assetName}
                          className="submissions-image-box"
                          onClick={() => handleImageClick(asset,true)}
                          style={{ cursor: 'pointer' }}
                        />

                        <div className="d-flex justify-content-between">
                          <small>
                            <b style={{ paddingLeft: '45px' }}>{asset.assetId}</b>
                          </small>
                          <small>
                            <b style={{ color: '#B01A00' }}>#{asset.amazonPosition || ''}</b>
                          </small>
                        </div>
                      </Card>
                    </Col>
                  ))
                ) : !loadScreen ? (
                  <Col md={12} className="text-center text-muted mt-5">
                    <p>No images available.</p>
                  </Col>
                ): null}

              </Row>
              </LoadingOverlay>
          </Col>
        </Row>
      </Col>

      {/* Add the missing modals */}
      <CustomModal
        header={
          <>
            Attachment
            <FontAwesomeIcon
              className={`ml-3 ${downloading ? 'button-img-background-download-inprogress' : ''}`}
              style={{ cursor: 'pointer' }}
              icon={faDownload}
              onClick={() => handleDownloadImage(filePath, selectedFileObject)}
            />
          </>
        }
        isOpen={isAttachmentOpen}
        toggle={() => { setIsAttachmentOpen(!isAttachmentOpen); setDownloading(false) }}
        size={"lg"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setIsAttachmentOpen(!isAttachmentOpen)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <div>
            <iframe
              src={filePath}
              title="File Display"
              width="100%"
              height="500"
            ></iframe>
          </div>
        </Label>
      </CustomModal>
      <CustomModal
        isOpen={isCommentsPopUpOPen}
        toggle={() => setIsCommentsPopUpOPen(false)}
        size="xl"
        // header={<p title={assetsName} className="comment-paragraph-ticket-history">{assetsName}</p>}
        className="curve-popup "
      >
        <LoadingOverlay
          active={loadScreen}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text="Loading chat details..."
        >
       
           <AssetsCommentsPopup
        filePath={filePath}
        demoImage={demoImage}
        noteList={noteList}
        setNote={setComment}
        note={comment}
        action={false}
        selectedFileObject={selectedFileObject}
        addCMAssetChats={addSubmissionsChats}
        />
        </LoadingOverlay>
      </CustomModal>
      <CustomModal
        isOpen={isImageDetails}
        toggle={() => setIsImageDetails(false)}
        size="xl"
        header={<p title={selectedImageAsset && selectedImageAsset.assetName} className="comment-paragraph-Project-asin-title">{selectedImageAsset && selectedImageAsset.assetName}</p>}
        className="curve-popup"
        >
        {selectedImageAsset && (
            <ProjectDashDeliveriesImagesDetails
            loggedInUser={loggedInUser}
            selectedProjectData={props.selectedProjectData}
            projectPermissions={props.projectPermissions}
            submissionData={props.submissionData}
            setDocumentStatusCount={setDocumentStatusCount}
            setDocumentTotal={setDocumentTotal}
            setGraphicsStatusCount={setGraphicsStatusCount}
            setGraphicsTotal={setGraphicsTotal}
            setAssetList={setAssetList}
            setSubmissionList={props.setSubmissionList}
            selectedImage={selectedImageAsset}
            setSelectedImage={setSelectedImageAsset}
            action={action}
            setSelectedImageAsset={setSelectedImageAsset}
            onClose={() => setIsImageDetails(false)}
            imageLocatorList={props.imageLocatorList}

            />
        )}
        </CustomModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
});

export default connect(mapStateToProps)(ProjectDashDeliveriesDetails);